/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'add': {
    width: 16,
    height: 16,
    viewBox: '0 0 55 54',
    data: '<g fill-rule="evenodd"><path pid="0" fill-rule="nonzero" d="M49 8V0H0v47h7v7h48V8h-6zM2 45V2h45v6H7v37H2zm51 7H9V10h44v42z"/><path pid="1" d="M42 30H32V20c0-.55-.45-1-1-1s-1 .45-1 1v10H20c-.55 0-1 .45-1 1s.45 1 1 1h10v10c0 .55.45 1 1 1s1-.45 1-1V32h10c.55 0 1-.45 1-1s-.45-1-1-1z"/></g>'
  }
})
